import styled from "styled-components";

import { StyledSelect } from "components/selects/single-select/styled";

export const StyledDateSelect = styled(StyledSelect)`
  border: 1px solid ${({ theme }) => theme.colors.neutral300};
  background-color: ${({ theme }) => theme.colors.transparent};
`;
